import { render, staticRenderFns } from "./SubpageNotifications.vue?vue&type=template&id=13ba55a0&scoped=true&"
import script from "./SubpageNotifications.vue?vue&type=script&lang=js&"
export * from "./SubpageNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba55a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ba55a0')) {
      api.createRecord('13ba55a0', component.options)
    } else {
      api.reload('13ba55a0', component.options)
    }
    module.hot.accept("./SubpageNotifications.vue?vue&type=template&id=13ba55a0&scoped=true&", function () {
      api.rerender('13ba55a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/notifications/SubpageNotifications.vue"
export default component.exports